import ButtonGroup from '@components/ButtonGroup/README.md';
import Common from '@components/Common/README.md';
import ConfirmButton from '@components/ConfirmButton/README.md';
import Content from '@components/Content/README.md';
import Descriptions from '@components/Descriptions/README.md';
import Drawer from '@components/Drawer/README.md';
import Enum from '@components/Enum/README.md';
import Features from '@components/Features/README.md';
import File from '@components/File/README.md';
import FileList from '@components/FileList/README.md';
import FilePreview from '@components/FilePreview/README.md';
import Filter from '@components/Filter/README.md';
import FlexBox from '@components/FlexBox/README.md';
import FormInfo from '@components/FormInfo/README.md';
import Global from '@components/Global/README.md';
import HelperGuide from '@components/HelperGuide/README.md';
import HistoryStore from '@components/HistoryStore/README.md';
import Icon from '@components/Icon/README.md';
import Image from '@components/Image/README.md';
import InfoPage from '@components/InfoPage/README.md';
import Layout from '@components/Layout/README.md';
import Menu from '@components/Menu/README.md';
import Modal from '@components/Modal/README.md';
import Navigation from '@components/Navigation/README.md';
import Permissions from '@components/Permissions/README.md';
import StateBar from '@components/StateBar/README.md';
import StateTag from '@components/StateTag/README.md';
import Table from '@components/Table/README.md';
import TablePage from '@components/TablePage/README.md';
import Tooltip from '@components/Tooltip/README.md';export default {ButtonGroup,Common,ConfirmButton,Content,Descriptions,Drawer,Enum,Features,File,FileList,FilePreview,Filter,FlexBox,FormInfo,Global,HelperGuide,HistoryStore,Icon,Image,InfoPage,Layout,Menu,Modal,Navigation,Permissions,StateBar,StateTag,Table,TablePage,Tooltip};